import { defineMessages } from 'react-intl';

export default defineMessages({
  TITLE: {
    defaultMessage: 'Colonnes affichées',
  },

  SELECTION_COUNT: {
    defaultMessage: '{selected} élément(s) sélectionné(s) sur {total}',
  },

  BUTTON: {
    defaultMessage: "Options d'affichage des colonnes",
  },
} as const);
